import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { useUserContext, Statescontex } from "../../context/index.js";
import { subscribeUser, unsubscribeUser } from "../../services/apicall.tsx";

const expandedLogo = require("../../devdata/icons/s_logo.png");
const PricingTier = ({
  title,
  price,
  subtitle,
  description,
  features,
  popular = false,
  saveText,
  accentColor = "",
  isHighlighted = false,
}: {
  title: "Yearly" | "Monthly";
  price: string;
  subtitle?: string;
  description: string;
  features: string[];
  popular?: boolean;
  saveText?: string;
  accentColor?: string;
  isHighlighted?: boolean;
}) => {
  const { userdetails, sub, userToken } = useUserContext();
  const { setErrorshow, setErrorMessage } = Statescontex();
  const [order, setorder] = useState();
  const [loading, setLoading] = useState(false);

  const handleSubscribe = () => {
    if (userdetails && userdetails.isverified === true) {
      subscribeUser(
        userToken,
        title,
        setLoading,
        setorder,
        setErrorMessage,
        setErrorshow
      );
    } else {
      setErrorshow(true);
      setErrorMessage("m_Please verify your email to continue");
    }
  };
  const handlePayment = async () => {
    try {
      setLoading(true);
      if (!order) {
        throw new Error("Order not set");
      }
      const orderData = order;
      // Initialize Razorpay
      console.log(process.env.REACT_APP_NODE_ENV, orderData);

      const options = {
        key:
          process.env.REACT_APP_NODE_ENV === "prod"
            ? process.env.REACT_APP_RAZORPAY_KEY_PROD
            : process.env.REACT_APP_RAZORPAY_KEY,
        amount: orderData.amount,
        currency: "INR",
        name: "MarketPulse.Exchange",
        description: `${orderData.subtype} Subscription`,
        image: expandedLogo,

        order_id: orderData.id,
        handler: function () {
          // Handle successful payment
          window.location.href = "/profile";
        },
        prefill: {
          name: userdetails.name,
          email: userdetails.username,
          contact: userdetails.phone,
        },
        theme: {
          color: "#01e47c",
        },
      };

      const rzp1 = new window.Razorpay(options);
      rzp1.on("payment.failed", function (response) {
        setErrorMessage(
          "h_Error: Payment failed. Please try again. " +
          response.error.description
        );
        setErrorshow(true);
      });
      rzp1.open();
    } catch (error) {
      console.error("Error creating order:", error);
      setErrorMessage("h_Error: Error creating order. Please try again.");
      setErrorshow(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (order) {
      handlePayment();
    }
  }, [order]);

  return (
    <div
      className={`group relative p-8 flex flex-col h-full rounded-2xl backdrop-blur-md bg-glass-gradient border border-white/10 shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-[1.02] hover:border-market-teal/50 ${popular
        ? "border-market-teal"
        : accentColor
          ? `border-${accentColor}`
          : ""
        }`}
    >
      {/* Animated ring effect */}
      <div className="absolute inset-0 rounded-2xl ring-2 ring-market-teal/0 group-hover:ring-market-teal/30 transition-all duration-300"></div>

      {popular && (
        <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-market-teal text-black text-xs font-bold py-1 px-3 rounded-full shadow-lg group-hover:scale-110 transition-transform duration-300">
          Most Popular
        </div>
      )}
      <h3
        className={`text-2xl font-bold mb-2 text-white group-hover:text-market-teal transition-colors duration-300 ${accentColor ? `text-${accentColor}` : ""
          }`}
      >
        {title}
      </h3>
      <div className="mb-2">
        <span className="text-4xl font-bold text-white group-hover:text-market-teal transition-colors duration-300">
          {price}
        </span>
        {subtitle && <span className="text-white/60 ml-1">{subtitle}</span>}
      </div>
      {saveText && (
        <div className="mb-4 text-market-teal font-medium text-sm">
          {saveText}
        </div>
      )}
      <p className="text-white/70 mb-6 group-hover:text-white/90 transition-colors duration-300">
        {description}
      </p>
      <div className="flex-grow">
        <ul className="space-y-3 mb-8">
          {features.map((feature, index) => (
            <li key={index} className="flex items-start group/item">
              <FontAwesomeIcon
                icon={faCheck}
                className={`h-5 w-5 ${accentColor ? `text-${accentColor}` : "text-market-teal"
                  } mr-2 mt-0.5 flex-shrink-0 group-hover/item:scale-110 transition-transform duration-300`}
              />
              <span className="text-white/80 group-hover/item:text-white transition-colors duration-300">
                {feature}
              </span>
            </li>
          ))}
        </ul>
      </div>
      {!sub?.issubexp ? (
        <>
          <p className="text-sm">
            Subscribed on:{" "}
            <span className="font-medium">
              {sub && sub.subon
                ? new Date(sub.subon).toLocaleDateString("en-GB")
                : "-"}
            </span>
          </p>
          <p className="text-sm mb-4">
            Expires on:{" "}
            <span className="font-medium">
              {sub && sub.subexp
                ? new Date(sub.subexp).toLocaleDateString("en-GB")
                : "-"}
            </span>
          </p>
          <div className="flex gap-2">
            <button
              className={`z-30 w-full rounded-lg py-3 text-center font-medium transition-all duration-300 cursor-pointer ${popular
                ? "bg-market-teal text-black hover:bg-market-teal/90"
                : isHighlighted
                  ? "bg-market-blue/80 hover:bg-market-blue/90 text-white"
                  : "bg-white/10 hover:bg-white/20 text-white"
                }`}
              onClick={() => handleSubscribe()}
            >
              {loading ? "Processing..." : "Renew"}
            </button>
          </div>
        </>
      ) : (
        <div className="flex items-center">
          <button
            className={`z-30 w-full rounded-lg py-3 text-center font-medium transition-all duration-300 cursor-pointer ${popular
              ? "bg-market-teal text-black hover:bg-market-teal/90"
              : isHighlighted
                ? "bg-market-blue/80 hover:bg-market-blue/90 text-white"
                : "bg-white/10 hover:bg-white/20 text-white"
              }`}
            onClick={() => handleSubscribe()}
            disabled={loading}
          >
            {loading ? "Processing..." : "Subscribe"}
          </button>
        </div>
      )}
    </div>
  );
};

const PricingPage = () => {
  const commonFeatures = [
    "Access to Pi - Predictive intelligence",
    "Access to all scanners",
    'Access to "Automate Via Algotest"',
    'Access to "Updated Learning Content"',
  ];

  return (
    <div className="min-h-screen bg-background dark:bg-black relative overflow-hidden">
      <div className="fixed inset-0 bg-grid-pattern bg-[size:20px_20px] pointer-events-none opacity-[0.015] z-0"></div>

      <main className="pt-20 sm:pt-32 pb-12 sm:pb-20">
        <section className="container mx-auto px-4 max-w-6xl">
          <div className="text-center mb-8 sm:mb-16">
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-3 sm:mb-4 text-white">
              Transparent <span className="text-market-teal">Pricing</span>{" "}
              Plans
            </h1>
            <p className="text-white/70 max-w-2xl mx-auto text-sm sm:text-base">
              Choose the plan that fits your trading needs. All plans include
              access to our advanced market analytics and real-time data.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-8 max-w-4xl mx-auto">
            <PricingTier
              title="Monthly"
              price="₹1,499"
              subtitle="/month"
              description="Full access to all features with monthly billing"
              features={commonFeatures}
              isHighlighted={true}
            />

            <div className="relative">
              <PricingTier
                title="Yearly"
                price="₹6,999"
                subtitle="/year"
                description="Full access to all features with yearly billing"
                features={commonFeatures}
                saveText="Save 61% (Only ₹584/month)"
                popular={true}
              />
            </div>
          </div>

          <div className="mt-12 sm:mt-20 max-w-3xl mx-auto rounded-xl bg-darkMode-layer1 border border-darkMode-layer2 p-4 sm:p-8 text-darkMode-text shadow-sm transition-all duration-300 hover:shadow-md">
            <h2 className="text-xl sm:text-2xl font-bold mb-4 text-center">
              Frequently Asked Questions
            </h2>
            <div className="space-y-4 sm:space-y-6">
              <div>
                <h3 className="text-darkMode-green font-semibold mb-2 text-sm sm:text-base">
                  Do you offer refunds?
                </h3>
                <p className="text-darkMode-subText text-sm sm:text-base">
                  No, we do not offer any refunds, kindly read{" "}
                  <Link
                    to="/refund"
                    className="text-darkMode-green hover:underline"
                  >
                    Refund Policy
                  </Link>{" "}
                  carefully.
                </p>
              </div>
              <div>
                <h3 className="text-darkMode-green font-semibold mb-2 text-sm sm:text-base">
                  Is my payment secure?
                </h3>
                <p className="text-darkMode-subText text-sm sm:text-base">
                  Yes, your payment is always secured by Razorpay.
                </p>
              </div>
              <div>
                <h3 className="text-darkMode-green font-semibold mb-2 text-sm sm:text-base">
                  Can I have EMI plans?
                </h3>
                <p className="text-darkMode-subText text-sm sm:text-base">
                  Yes, you can choose various EMI plans that are supported by
                  Razorpay & your bank, at checkout page.
                </p>
              </div>
              <div>
                <h3 className="text-darkMode-green font-semibold mb-2 text-sm sm:text-base">
                  What payment methods do you accept?
                </h3>
                <p className="text-darkMode-subText text-sm sm:text-base">
                  We accept all major credit cards, debit cards, net banking and
                  UPI transactions.
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default PricingPage;
